module.exports = __webpack_public_path__ + "img/r6.88154d3c.png";